import { languages } from "./languages";

export type SupportedLocale = keyof typeof languages;

export const supportedLngs = Object.keys(languages);

export const defaultLocale = "fr";

export default languages;

export { languages };
